@let paymentProviders = paymentProviderStore.paymentProviders;
@if (paymentProviderStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (paymentProviders() && !paymentProviderStore.isLoading()) {
  <div
    class="box-border flex w-full text-base"
    [ngClass]="{
      'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    }"
    [ngStyle]="{
      backgroundColor: inputBackground(),
    }">
    @let hasError = ngControl.errors && ngControl.touched;
    <div class="rounded-input relative w-full bg-inherit">
      <input
        [attr.data-testid]="id() | appendTestId: 'input'"
        autocomplete="off"
        readonly
        class="border-input-ring border-input rounded-input peer p-input w-full cursor-pointer bg-transparent placeholder-transparent focus:ring-0"
        [ngClass]="{
          'border-input-error focus:border-input-focus': hasError,
          'border-input-ring focus:border-input-focus': !hasError,
          'pointer-events-none': ngControl.disabled,
        }"
        [id]="id()"
        [placeholder]="ngControl.value?.filename || label() || ''"
        type="text" />
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        class="pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit px-1 transition-all"
        [ngClass]="{
          'text-input-error': hasError,
          '-top-2.5 text-xs text-input-label peer-focus:text-input-focus':
            ngControl.value,
          'peer-placeholder-shown:text-input-label peer-focus:text-input-focus -top-2.5 text-xs peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2.5 peer-focus:text-xs':
            !ngControl.value,
        }"
        [for]="id()">
        {{ ngControl.value?.filename || label() }}
      </label>
      @if (ngControl.value) {
        <div
          [attr.data-testid]="id() | appendTestId: 'value'"
          class="pointer-events-none absolute top-3.5 right-6 left-4 flex items-center gap-2 truncate">
          <img
            [src]="paymentProviderStore.getThumbnailPath(ngControl.value.id)"
            alt="PaymentProvider Preview"
            class="h-6" />
        </div>
      }
      @if (showList()) {
        <div class="fixed top-0 right-0 bottom-0 left-0 z-10 w-full"></div>
      }
      <div
        tabindex="-1"
        [attr.data-testid]="id() | appendTestId: 'options'"
        [ngClass]="{ hidden: !showList() }"
        class="focus:border-input-focus border-input-ring bg-primary-on border-input rounded-input absolute z-10 flex max-h-[300px] w-full flex-col gap-2 overflow-y-scroll focus:outline-hidden">
        @for (
          paymentProvider of paymentProviders();
          track paymentProvider.id;
          let index = $index
        ) {
          <li
            class="p-drop-down-list-item hover:bg-standard-hover-main flex cursor-pointer flex-row items-center"
            [ngClass]="{
              'text-input-focus': ngControl.control!.value === paymentProvider,
              'bg-standard-hover': selectedItem() === index,
              'rounded-t-lg': index === 0,
              'rounded-b-lg': index === paymentProviders()!.length - 1,
            }"
            (click)="selectPaymentProvider(paymentProvider)">
            <img
              [src]="paymentProviderStore.getThumbnailPath(paymentProvider.id)"
              alt="PaymentProvider Preview"
              class="h-10 pr-2" />
            {{ paymentProvider.filename }}
          </li>
        }
        @if (paymentProviders()!.length === 0) {
          <div
            class="p-drop-down-list-item"
            [attr.data-testid]="id() | appendTestId: 'option'">
            {{
              textStore.texts()
                | filterTexts: ERelationType.noOptions : EEntityType.generic
                | language
            }}
          </div>
        }
      </div>
      @if (hasError && !errorTemplate()) {
        <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
          <ng-content></ng-content>
        </aw-error-message>
      }
      @if (hasError && errorTemplate()) {
        <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
          <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
        </aw-error-message>
      }
    </div>
  </div>
}
